<template>
  <div>
    <div class="trow" v-for="(item, index) in value" :key="index">
      <div class="tcol">
        <span class="key">
          {{ item.key }}
        </span>
      </div>
      <div class="tcol">
        <object-viewer
          v-if="Array.isArray(item.value)"
          :data="item.value"
          :built="true"
        />
        <span class="value break-all" v-else>
          {{ item.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ObjectViewer",

  props: {
    data: { required: true },
    built: { type: Boolean, default: false },
  },

  computed: {
    value() {
      if (this.built) return this.data;
      else return this.buildData(this.data);
    },
  },

  methods: {
    buildData(data) {
      if (data) {
        if (Array.isArray(data)) {
          return data.map((item) => this.buildData(item));
        } else if (typeof data === "object") {
          return Object.keys(data).map((key) => ({
            key,
            value: this.buildData(data[key]),
          }));
        }

        return data;
      }

      return "N/A";
    },
  },
};
</script>

<style scoped>
.trow {
  padding: 10px 25px 10px 25px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  border: 2px solid whitesmoke;
  border-radius: 4px;
}

.trow > .tcol {
  width: 100%;
}

.trow > .tcol > span {
  white-space: pre-wrap;
}

.key {
  color: red;
}
.value {
  color: grey;
}
</style>